import type {Client} from '@prismicio/client';
import type {ResourcesCenterHeaderDocument} from '@prismicio-types';
import {useLogger, usePrismicLang, useSpanWrap} from '#imports';
/**
 * Retrieve document from Prismic repository.
 */

export default async function usePrismicHeader(client: Client) {
    const logger = useLogger();
    const {lang} = usePrismicLang();

    try {
        const getPrismicDocument = () => client!.getSingle<ResourcesCenterHeaderDocument>('resourcesCenterHeader', {lang: lang.value});
        return await useSpanWrap(getPrismicDocument, {httpMethod: 'prismic.get', kind: 'prismic', name: '[prismic] resourcesCenterHeader'});
    } catch (err) {
        logger.info(err);
        logger.info(`Could not retrieve document from Prismic with parameters: [resourcesCenterHeader, ${lang.value}]`);
    }

    // if the document does not exist, check for redirect or throw 404
}
